import { ReservationRes, HomeResourcesRes } from "@/interface";
import { formatLocalTime } from "@/utils/util";

export const convertHomeRes = (res: HomeResourcesRes, isDev: boolean) => {
  const reservationsMap = convertReservationRes(res.reservations);
  const homeResources = res.resources;
  if (!isDev) {
    homeResources.courseGroup = homeResources.courseGroup.filter(
      (courseGroup: any) => {
        courseGroup.courses = courseGroup.courses.filter(
          (course: any) => !course.dev
        );
        return courseGroup.courses.length;
      }
    );
  }
  return {
    ...homeResources,
    reservationsMap
  };
};

export const canEnterClass = (date?: string) => {
  if (date && date.length) {
    const reservationDate = new Date(date);
    const now = new Date();
    console.log("reservationDate:", reservationDate, "; now:", now);
    if (Math.abs(reservationDate.getTime() - now.getTime()) < 600000) {
      return true;
    }
  }

  return false;
};

const convertReservationRes = (reservations: ReservationRes[]) => {
  return (reservations || []).reduce(
    (result: any, reservation: ReservationRes) => {
      return {
        ...result,
        [reservation.course_id]: {
          ...reservation
        }
      };
    },
    {}
  );
};
